import { render } from "./SingleCriteria.vue?vue&type=template&id=25af7ab4"
import script from "./SingleCriteria.vue?vue&type=script&lang=js"
export * from "./SingleCriteria.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__